const navValues = {
    login: "Login",
    list: "TableauDashboardList",
    dashboard: "Dashboard",
    settings: "UserSettings"
};

export default navValues;